import { useEffect } from 'react';
import { Flex } from '@servicetitan/anvil2';
import { ErrorBoundary } from '@servicetitan/financing-utils-shared';
import { SecondLookFinancingInformationContainer } from '@servicetitan/financing-plans-shared';
import { plansPanel, wrapper } from '../workflow/ApplicationWorkflow.module.scss';

interface SelectSecondLookStepProps {
    skipSelectProvider?: boolean;
    onPrequalifySelected?: () => void;
}

export const SelectSecondLookStep = (props: SelectSecondLookStepProps) => {
    const { skipSelectProvider = true, onPrequalifySelected } = props;

    useEffect(() => {
        if (skipSelectProvider && onPrequalifySelected) {
            onPrequalifySelected();
        }
    }, [skipSelectProvider, onPrequalifySelected]);

    if (skipSelectProvider) {
        return null;
    }

    return (
        <div className={plansPanel} style={{ width: '100%' }}>
            <div className={wrapper}>
                <Flex direction="column" gap="4">
                    <ErrorBoundary actionCausingError="loading second look options">
                        <SecondLookFinancingInformationContainer
                            showProviderSelection
                            onSubmitAction={onPrequalifySelected}
                        />
                    </ErrorBoundary>
                </Flex>
            </div>
        </div>
    );
};
